import { RadioProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import Icon from "~widgets/icon"
import styled from '~/ui/styled'

const RadioWrapper = styled.Pressable`
  flex-direction: row;
  align-items: center;
`

const RadioLabel = styled.Text`
  margin-right: 5px;
`

const Radio: React.FC<RadioProps> = ({ curValue, value, label, onClick }) => {
  const theme = useTheme()
  const checked = curValue === value
  return (
    <RadioWrapper onClick={() => onClick?.(value)}>
      {!!label && <RadioLabel>{label}</RadioLabel>}
      {checked ? (
        <Icon name="check" color={theme.colors.primary} size={30} />
      ) : (
        <Icon name="check" color={theme.colors.border} size={30} />
      )}
    </RadioWrapper>
  )
}

export default Radio
